var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4771 3.40023L13.0104 1.93359L8.4104 6.60026L3.81038 1.93359L2.34375 3.40023L7.01042 8.00024L2.34375 12.6003L3.81038 14.0669L8.4104 9.40023L13.0104 14.0669L14.4771 12.6003L9.81038 8.00024L14.4771 3.40023Z",
    fill: "#C14F29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIconOrange);
export default __webpack_public_path__ + "static/media/cancelIconOrange.ae8524beb114a38ba5fb5ecb3501bbda.svg";
export { ForwardRef as ReactComponent };